import React, { useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useRestClient } from '../../../core/api/RestClientContext';
import { Button } from '../../../core/components/Button';
import { Input, Label } from '../../../core/components/FormElements';
import { Modal } from '../../../core/components/Modal';
import './XuiExportDialog.css';

interface Props {
    initialFlow?: string;
    onClose: () => void;
}

export const XuiExportDialog: React.FC<Props> = ({ initialFlow = 'xtls-rprx-vision', onClose }) => {
    const restClient = useRestClient();
    const [flow, setFlow] = useState<string>(initialFlow);
    const [loading, setLoading] = useState(false);
    const [json, setJson] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);

    const pretty = useMemo(() => {
        if (json == null) return '';
        try {
            return JSON.stringify(json, null, 2);
        } catch {
            return String(json);
        }
    }, [json]);

    const handleLoad = async () => {
        setError(null);
        setLoading(true);
        try {
            const data = await restClient.getXuiClients(flow ? { flow } : undefined);
            setJson(data);
        } catch (e: any) {
            setError(e?.message || 'Ошибка загрузки JSON');
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(pretty);
            toast.success('JSON скопирован в буфер обмена');
        } catch {
            toast.error('Не удалось скопировать в буфер');
        }
    };

    return (
        <Modal onClose={onClose} className="xed-dialog">

            <div className="xed-controls">
                <div className="xed-field">
                    <Label>flow</Label>
                    <Input
                        value={flow}
                        onChange={(e) => setFlow(e.target.value)}
                        disabled={loading}
                        placeholder="xtls-rprx-vision"
                    />
                </div>

                <div className="xed-actions">
                    <Button variant="primary" onClick={handleLoad} loading={loading}>
                        Загрузить
                    </Button>
                    <Button variant="secondary" onClick={handleCopy} disabled={!pretty || loading}>
                        Скопировать
                    </Button>
                </div>
            </div>

            {error && <div className="xed-error">{error}</div>}

            <textarea
                className="xed-json"
                readOnly
                value={pretty}
                placeholder="Нажми «Загрузить», чтобы получить JSON…"
            />
        </Modal>
    );
};

export default XuiExportDialog;
